<template>
  <div>
    <el-dialog
      :visible.sync="show"
      show-cancel-button
      width="1200px"
      style="
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0.6) 0%,
          rgba(255, 255, 255, 0) 100%
        );
      "
    >
      <div style="margin:20px；width:1200px">
        <div>
          <p
            style="
              font-size: 20px;
              line-height: 20px;
              margin: 0px;
              orphans: 0;
              text-align: center;
              widows: 0;
            "
          >
            <el-image
              style="position: relative; top: -10px"
              :src="require('../../../assets/images/3.png')"
            />
            <span
              style="
                font-family: 仿宋;
                font-size: 28px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #131295;
                position: relative;
                top: -20px;
                margin: 0 10px;
              "
            >{{title}}</span>
            <el-image
              style="position: relative; top: -10px"
              :src="require('../../../assets/images/4.png')"
            />
          </p>
          <div
            ref="main"
            class="main"
            style="padding: 20px 35px; overflow-y: scroll;height:350px;"
          >
            <div v-html="content"></div>
          </div>
          <div class="btnWrap">
            <!-- <div class="nextStepBtn" @click="goFalse">取消</div> -->
            <div
              class="nextStepBtn sureBtn"
              style="
                  width: 200px;
                  height: 40px;
                  background: #0f40b9;
                  border-radius: 4px;
                  margin: 0 auto;
                  color: #fff !important;
                "
              @click="goOk"
            >
              我已阅读
            </div>
          </div>
        </div>
        <p style="margin: 0px; orphans: 0; text-align: justify; widows: 0">
          <span style="font-family: Calibri; font-size: 10.5px">&#xa0;</span>
        </p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/* global http protocol */
export default {
  data() {
    return {
      show: false,
      title: null,
      content: null
    }
  },
  methods: {
    showDia(id) {
      protocol.param_getContentDetails.param.id = id
      http.getRes(protocol.param_getContentDetails).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          this.title = value.title
          this.content = value.content
          this.show = true
          this.$nextTick(() => {
            this.$refs.main.scrollTop = 0
          })
        } else {
          this.$toast(message)
        }
      })
    },
    goFalse() {
      this.show = false
    },
    goOk() {
      this.show = false
      this.$emit('confirm')
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-dialog {
  background: linear-gradient(
    265deg,
    rgba(255, 255, 255, 0.6) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  background: url("../../../assets/images/1.png") no-repeat;
  background-size: 100% 100%;
  height: 530px;
  * {
    color: #0000ff !important;
  }
}
.main {
  background: url("../../../assets/images/2.png") no-repeat;
  background-size: 100% 150%;
  min-height: 350px !important;
  color: #0000ff !important;
}
.main::-webkit-scrollbar-thumb {
  border-radius: 4px;
}
.main::-webkit-scrollbar-thumb {
  background-color: #D4D4D4;
}
.main::-webkit-scrollbar {
  height: 10px;
}
.el-dialog {
  height: 90vh;
  margin-top: 5vh;
  overflow: scroll;
}
/deep/ .el-dialog__footer {
  display: none;
}
.btnWrap {
  display: flex;
  padding: 10px 20px;

  .nextStepBtn {
    // flex: 1;
    height: 40px;
    line-height: 40px;
    text-align: center;
    margin: 0 auto;
  }
}
.btnWrap > div:first-child {
  margin-right: 20px;
  color: #fff;
  background-color: transparent;
  // border: 1px solid #979797;
}
.sureBtn {
  background-color: #2483ff;
  color: #fff;
}
</style>
